import { Pipe, PipeTransform } from '@angular/core';
import {formatPercent} from '@angular/common';
import {PERT_DIGITS_INFO, PERT_LOCALE} from '../format-percentagem';

@Pipe({
  name: 'customPercentage'
})
export class CustomPercentagePipe implements PipeTransform {

  transform(
    value: number,
    digitsInfo = PERT_DIGITS_INFO,
    locale = PERT_LOCALE,
  ): string | null {
    let pert = 0;
    if (isNaN(value)) {
      pert = 0;
    } else if (value === undefined) {
      pert = 0;
    } else if (value === Infinity) {
      pert = 0;
    } else {
      pert = value / 100;
    }
    return Number(pert).toLocaleString(undefined, {style: 'percent', minimumFractionDigits: 1});
  }

}
